<template>
  <el-row type="flex" justify="space-around">
    <el-col :lg="20" :md="24" :sm="24">
      <el-card class="box-card" style="margin-top: 30px">
        <div slot="header" class="clearfix">
          <el-row>
            <el-col :lg="23" :md="22" :sm="22" :xs="20">
              <div style="width: 100%; text-align: center">
                <span style="font-size: 20px; font-weight: 600"
                  >{{ deptName }}单位简介</span
                >
              </div>
            </el-col>
            <el-col :lg="1" :md="2" :sm="2" :xs="4">
              <el-button type="primary" @click="doSave(this)">保存</el-button>
            </el-col>
          </el-row>
        </div>
        <el-row>
          <el-col :span="24">
            <el-input
              v-model="deptDesc"
              clearable
              type="textarea"
              maxlength="1500"
              show-word-limit
              :rows="20"
              :autosize="{ minRows: 20, maxRows: 50 }"
              placeholder="单位介绍"
            />
          </el-col>
        </el-row>
      </el-card>
    </el-col>
  </el-row>
</template>

<script>
import {
  getDepartmentByDeptCode,
  saveRemark,
} from "@/api/recruit/hr/recruitInfo";
import { messageDuration } from "../../../config/settings";

export default {
  name: "DeptDesc",
  data() {
    return {
      deptDesc: "",
      deptName: "",
      /*buttonValue: "编辑",*/
    };
  },
  async created() {
    await this.loadDeptInfo();
  },
  methods: {
    async loadDeptInfo() {
      /*传参数为当前登录用户的deptCode*/
      let data = await getDepartmentByDeptCode({
        deptCode: this.$store.getters["user/deptCode"],
      });
      if (data.success) {
        this.deptDesc = data.data.remark;
      } else {
        this.$message.error({ showClose: true, message: data.message });
      }
    },
    /*doEdit() {
      if (this.buttonValue == "编辑") {
        this.buttonValue = "保存";
      } else if (this.buttonValue == "保存") {
        let flag = this.doSave();
        if (flag) this.buttonValue = "编辑";
      }
    },*/
    async doSave() {
      let answer = await saveRemark({
        deptCode: this.$store.getters["user/deptCode"],
        remark: encodeURIComponent(this.deptDesc),
      });
      if (answer.success) {
        this.$message.success({
          showClose: true,
          message: "保存成功",
          type: "success",
          duration: messageDuration,
        });
      } else {
        this.$message.error({
          showClose: true,
          message: data.message,
          type: "error",
        });
      }
    },
  },
};
</script>

<style scoped></style>
